/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * @export
 * @interface ResendCodeRequest
 */
export interface ResendCodeRequest {
    userId?: string | null;
}

export function ResendCodeRequestFromJSON(json: any): ResendCodeRequest {
    return ResendCodeRequestFromJSONTyped(json, false);
}

export function ResendCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendCodeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function ResendCodeRequestToJSON(value?: ResendCodeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_id': value.userId,
    };
}
